var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMySummaryBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_286_1",
    "data-name": "Component 286 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 411.333,
    height: 87.617,
    viewBox: "0 0 411.333 87.617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.073,
    y1: 0.084,
    x2: 1.436,
    y2: 1.618,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20c5a0",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#0ab3d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02acec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MySummary",
    transform: "translate(0.333 0.566)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "primaryGradient",
    width: 411,
    height: 87,
    opacity: 0.401,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "whiteOverylay",
    width: 411,
    height: 87,
    fill: "#fff",
    opacity: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M1233-3019s-127.463-9.45-228.274,48.895-183.058,2.739-183.058,2.739v35.418H1233Z",
    transform: "translate(-821.667 3019.566)",
    fill: "#fff",
    opacity: 0.402
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMySummaryBg);
export default __webpack_public_path__ + "static/media/mySummaryBG.9dc465ec09abe6230265a26f98daaf9f.svg";
export { ForwardRef as ReactComponent };